var alignmentStyle = {"alignLeft":"pcvgk","textWrapNowrap":"VWqeJ","alignRight":"PPG2B","alignCenter":"_5G9Iq","sizeFullWidth":"xlOs2","renderedInTable":"CpaI-","sizeOriginal":"LRYEv","sizeContent":"_2uwTU","sizeSmall":"hGzW-","sizeSmallCenter":"_1dU74","flex":"_0NlBq","LEFT":"X4P6A","CENTER":"aMNpl","RIGHT":"a08n5","AUTO":"e6eRs","JUSTIFY":"fVSe5"};

export { alignmentStyle as a };
//# sourceMappingURL=alignment.rtlignore-497f926e.js.map
